<template lang="pug">
div.report-test
  div
    Table(:columns="columns1" :data="reportdata" )
    Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords"
         :page-size="10" :current="pageData.pageNo" show-elevator show-total)
      span 当前有{{reportdata.length}}条数据,共{{pageData.totalRecords}}条数据
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      isalldelete: false,
      multipleSelection: [], // 多选
      isreport: true,
      isdelete: true,
      scoredata: [], // 智能评分初始数据
      form: {
        classId: "",
        userName: "",
        experimentMemberAuditStatus: ""
      },
      infoorseache: true,
      classinfoend: [], // 查询班级名称最终数据
      classinfo: [], // 查询班级名称未处理数据
      showCheckbox: false,
      casename: "",
      experimentId: "",
      secondshow: false,
      page: 1,
      pageData: {}, // 分页总数
      // pageData1: {}, // 二级页面分页总数
      reportdata: [], // 一级页面数据
      // seconddata: [], // 二级页面数据
      columns1: [
        // 一级页面参数
        // {
        //   title: "序号",
        //   type: "index"
        // },
        {
          title: "实验名称",
          width: "156",
          key: "name",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.name
                  }
                },
                params.row.name
              )
            ]);
          }
        },
        {
          title: "完成阶段",
          width: "92",
          key: "distribution"
        },
        {
          title: "开始时间",
          width: "175",
          key: "startTime",
          render: (h, params) => {
            return h("div", [h("span", dayjs(params.row.startTime).format("YYYY-MM-DD HH:mm:ss"))]);
          }
        },
        {
          title: "结束时间",
          width: "175",
          key: "endTime",
          render: (h, params) => {
            return h("div", [h("span", dayjs(params.row.endTime).format("YYYY-MM-DD HH:mm:ss"))]);
          }
        },
        {
          title: "实验班级",
          width: "130",
          key: "classNames",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.classNames
                  }
                },
                params.row.classNames
              )
            ]);
          }
        },
        {
          title: "分配者",
          key: "createUserId",
          width: "90",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          render: (h, params) => {
            return h(
              "Tooltip",
              {
                props: {
                  content: params.row.createUserName,
                  placement: "top"
                }
              },
              params.row.createUserId,
              [h("p", {}, params.row.createUserName)]
            );
          }
        },
        {
          title: "实验状态",
          width: "92",
          key: "toState"
        },
        {
          title: "审核状态",
          width: "92",
          key: "experimentAuditStatus",
          render: (h, params) => {
            console.log(params.row);
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "5px",
                    color:
                      // eslint-disable-next-line no-nested-ternary
                      params.row.experimentAuditStatus === "已审批"
                        ? "#00A854"
                        : params.row.statusColor
                          ? "#F04B60"
                          : "#CCCCCC"
                  }
                },
                "●"
              ),
              h(
                "span",
                {
                  style: {
                    color: params.row.experimentAuditStatus === "已审批" ? "#000000" : "#000000"
                  }
                },
                params.row.experimentAuditStatus
              )
            ]);
          }
        },
        {
          title: "操作",
          width: 173,
          render: (h, params) => {
            console.log(this.$role.role);
            return h("div", [
              h(
                "i",
                {
                  class: "ivu-icon icon-chakan1 iconfont",
                  style: "font-size:14px;color:#3A76D2;",
                  props: {
                    type: "text",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/Teacher/reportManage2",
                        query: {
                          name: params.row.name,
                          experimentId: params.row.id,
                          caseExperimentDistribution: params.row.caseExperimentDistribution,
                          scoreType: params.row.scoreType
                        }
                      });
                      // this.secondshow = true;
                      // console.log(params.row);
                      // this.casename = params.row.name;
                      // this.experimentId = params.row.id;
                      // this.showExperimentMeber();
                      // this.showExperimentMeber1();
                    }
                  }
                },
                "查看"
              ),
              h(
                "i",
                {
                  style: "padding: 0 6px;color:#D8D8D8;"
                },
                "|"
              ),
              h(
                "i",
                {
                  class: "ivu-icon icon-xiazai iconfont",
                  style:
                    "font-size:14px;padding-bottom: 2px;color:#3A76D2;cursor:pointer;margin-right:4px;",
                  props: {
                    type: "text",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      console.log(params.row);
                      if (params.row.toState !== "已结束") {
                        this.$Message.warning("请先完成实验!");
                      } else if (params.row.experimentAuditStatus !== "已审批") {
                        this.$Message.warning("请先为报告评分!");
                      } else if (params.row.experimentAuditStatus === "未提交") {
                        this.$Message.warning("请先完成实验!");
                      } else {
                        this.exportexcel(params.row);
                      }
                    }
                  }
                },
                "下载详情"
              )
              // ,
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "text",
              //       size: "small"
              //     },
              //     on: {
              //       click: () => {
              //         this.classover(params.row);
              //       }
              //     }
              //   },
              //   "结束实验"
              // )
            ]);
          }
        }
      ]
    };
  },
  methods: {
    downloadFile(url, fileName) {
      // 一级页面下载单个文件
      const a = document.createElement("a");
      a.href = url;
      if (fileName) {
        a.download = fileName;
      } else {
        a.download = "";
      }
      a.click();
    },
    exportexcel(row) {
      // 一级页面下载详情
      const data = [];
      const data1 = JSON.parse(row.classIds);
      data1.forEach(ele => {
        data.push({ classId: ele, experimentId: row.id });
      });
      this.$http.exportScore(data).then(res => {
        if (res.data.success) {
          this.downloadFile(res.data.data);
          // console.log(res.data.data)
          this.$Message.success("正在下载");
        }
      });
    },
    handleCurrentChange(x) {
      // 分页函数
      this.queryExperiment(x);
    },
    classover(row) {
      // 结束实验
      this.$Modal.confirm({
        title: "系统提示",
        content: "<p>确定结束该实验吗?</p>",
        onOk: () => {
          this.overclass(row);
        }
      });
    },
    overclass(row) {
      console.log(row);
      const data = {
        classId: JSON.parse(row.classIds),
        experimentId: row.id
      };
      this.$http.finishExperiment(data).then(res => {
        if (res.data.success) {
          this.$Message.success("已结束实训");
          this.queryExperiment();
        }
      });
    },
    queryExperiment(x) {
      // 一级页面查询数据
      const data = {
        pageNo: x,
        userId: this.$role.code,
        pageSize: 10
      };
      this.$http.queryExperiment(data).then(res => {
        this.pageData = res.data.data;
        this.reportdata = res.data.data.list;
        // console.log(this.reportdata.id);
        this.reportdata.forEach(ele => {
          const i = ele;
          if (i.classNames) {
            const data2 = JSON.stringify(JSON.parse(i.classNames));
            i.classNames = "";
            JSON.parse(data2).forEach((e, index) => {
              if (index < JSON.parse(data2).length - 1) {
                i.classNames += `${e}、`;
              } else {
                i.classNames += e;
              }
            });
          }
          if (i.adminCreate) {
            i.userId = "admin";
          }
        });
      });
    }
  },
  created() {
    this.queryExperiment();
  }
};
</script>
<style lang="stylus">
.box
  // width 1200px!important
  .report-test
    text-align left
    overflow hidden
    .page
      float right
      margin-top 20px
    // table
    // width auto!important
    .ivu-table-tip
      tr
        td
          &:last-child
            border-radius 8px 8px 8px 8px !important
    .ivu-page-total
      span
        color #999999
        font-size 14px
    .ivu-page-item-active
      background #57A3F3
      a
        color #FFFFFF
    .ivu-table-wrapper
      border-color #EEF2F5
      .ivu-table:after
        background #EEF2F5
        z-index -99
      .ivu-table:before
        background-color #EEF2F5
      .ivu-table
        background #EEF2F5
        padding-bottom 2px
        font-size 14px
        thead
          tr
            th
              background #EEF2F5
              font-weight bolder
              color #000
              // text-align center
        tbody
          tr
            td
              // text-align: center;
              // border-top 1px solid #b7b7b7
              border-collapse unset
              box-sizing border-box
              height 40px
              &:first-child
                // border-left 1px solid #b7b7b7
                border-radius 8px 0 0 8px
              &:last-child
                // border-right 1px solid #b7b7b7
                border-radius 0 8px 8px 0
            &:last-child
              td
                // border-bottom 1px solid #b7b7b7 !important
    .secondtitle
      width 100%
      height auto
      margin 30px 0 30px 0
      .secondbtn1
        display inline-block
        margin-right 35px
      .secondbtn
        display inline-block
        margin-right 16px
      .info
        width 180px
        margin-right 16px
</style>
